import { Injectable } from '@angular/core';

import { PopperContentComponent } from '@frontend/vanilla/features/popper';

@Injectable({ providedIn: 'root' })
export class MarketHeaderTooltipService {
    private _tooltip: PopperContentComponent | null = null;

    set tooltip(popper: PopperContentComponent) {
        if (this._tooltip) {
            this.closeTooltip();
        }

        this._tooltip = popper;
    }

    get tooltip(): PopperContentComponent | null {
        return this._tooltip;
    }

    closeTooltip(): void {
        if (this._tooltip) {
            this._tooltip.close();
            this._tooltip = null;
        }
    }
}
